import { boot } from 'quasar/wrappers';
import { hasAccess } from 'src/services/security';
import {
  showAccessDeniedNotify,
  showPleaseSignInNotify,
} from 'src/services/notify';
import { Users } from 'src/api/services/users';

export default boot(({ router, store, redirect }) => {
  // const title = ref('Some title');
  // const dash = 'Distribution Dashboard';
  //
  // useMeta(() => {
  //   return {
  //     title: title.value,
  //   };
  // });
  //
  // function setPageTitle(value: string) {
  //   title.value = value ? `${value} — ${dash}` : dash;
  // }

  router.beforeEach((to, from, next) => {
    // void store.dispatch('app/setPageTitle', ''); // why?

    const user = store.state.app.user as unknown as Users.Types.User;

    if (hasAccess(user, to)) {
      // void store.dispatch('app/setPageTitle', to.meta['title'] as string);
      next();
      return;
    }

    if (user) {
      showAccessDeniedNotify(to.meta['title'] as string, () =>
        redirect({ name: 'logout' } /*, 302*/)
      );
      // void store.dispatch('app/setPageTitle', 'Access Denied');
    } else {
      redirect({ name: 'login' });
      showPleaseSignInNotify();
    }

    return;
  });
});

// export default ({ urlPath, redirect }) => {
//   // ...
//   const isAuthorized = // ...
//   if (!isAuthorized && !urlPath.startsWith('/login')) {
//     redirect({ path: '/login' })
//     // (@quasar/app 2.1.9+)
//     // or with a HTTP Status Code:
//     // redirect({ path: '/login' }, 302)
//     return
//   }
//   // ...
// }
